import { IconProps } from "./IconProps";

const CloseIcon: React.FC<IconProps> = ({
  width = 14,
  height = 14,
  color = "#000000",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 10 10" fill="none">
      <path
        d="M1.46387 8.53484L8.53587 1.46484M1.46387 1.46484L8.53587 8.53484"
        stroke={color}
        strokeWidth={"1.5"}
        strokeLinecap={"round"}
      />
    </svg>
  );
};
export default CloseIcon;
